import { Deserializable } from '../../../lib/models/deserializable';

export class ApplicationProductRepaymentMethod implements Deserializable {
  public ApplicationProductRepaymentMethodID: number;
  public ApplicationProductID?: number;
  public RepaymentMethodCode: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
